module.exports = __webpack_public_path__ + "static/img/labour-10.e56917f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-10.png
// module id = SbMp
// module chunks = 1